import React from 'react';
import { SectionTag } from '../ui/SectionTag';
import { ScrollHintTable } from '../ui/ScrollHintTable';
import { valueRows, valueTotal } from '../../data/content';
export function ValueTable() {
  return <section className="bg-cream py-10 sm:py-14" data-id="element-169" data-mp="34dvk3p63z6zm">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-170" data-mp="34b93z155jj5s">
        <SectionTag data-id="element-171" data-mp="2zdr19shqa068">Valor real</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-extrabold uppercase leading-tight text-navy sm:text-4xl" data-id="element-172" data-mp="3ebtaojbfxfve">
          Esto tiene valor real
        </h2>
      </div>

      <div className="mx-auto mt-8 max-w-2xl px-4 sm:px-6" data-id="element-173" data-mp="39cgdp5quusf3">
        <ScrollHintTable minWidth="440px" data-id="element-174" data-mp="3n4d1ixlhqg5o">
          <table className="w-full text-left text-sm" data-id="element-175" data-mp="3n67mud0ocaaa">
            <thead data-id="element-176" data-mp="3j29qga2qhdkx">
              <tr className="border-b border-navy/10 bg-navy/5 text-xs uppercase tracking-wide text-navy" data-id="element-177" data-mp="3j31k3fcrt18k">
                <th className="px-5 py-3 font-semibold" data-id="element-178" data-mp="xeuq79oloqy">Concepto</th>
                <th className="px-5 py-3 text-right font-semibold" data-id="element-179" data-mp="3s3zgpckvq6h4">Valor individual</th>
              </tr>
            </thead>
            <tbody data-id="element-180" data-mp="22zpnj42sgket">
              {valueRows.map(row => <tr key={row.concept} className="border-b border-navy/5" data-id="element-181" data-mp="27wpuribdjt7i">
                  <td className="px-5 py-4 text-ink" data-id="element-182" data-mp="2cwc77pjdp5f9">{row.concept}</td>
                  <td className="whitespace-nowrap px-5 py-4 text-right text-muted line-through" data-id="element-183" data-mp="2cv129me75rmk">{row.value}</td>
                </tr>)}
              <tr className="bg-orange/10" data-id="element-184" data-mp="2lxiqg6dewuc7">
                <td className="px-5 py-4 font-heading font-bold uppercase tracking-wide text-navy" data-id="element-185" data-mp="2lwqswq098mja">
                  Valor total
                </td>
                <td className="whitespace-nowrap px-5 py-4 text-right font-heading text-lg font-bold text-orange-hover" data-id="element-186" data-mp="2vmae42bfwshb">
                  {valueTotal}
                </td>
              </tr>
            </tbody>
          </table>
        </ScrollHintTable>
      </div>
    </section>;
}